import React, { Component, useEffect, useState } from "react"
import PropTypes from "prop-types"
import axios from "axios"
import {
	Grid,
	Box,
	Typography,
	Fade,
	Paper,
	Avatar,
	makeStyles,
	MenuItem,
} from "@material-ui/core/"
import BlogOverview from "./BlogOverview"
import Skeleton from "@material-ui/lab/Skeleton"
import { useTranslation } from "react-i18next"
import i18n from "i18next"
import Seo from "../components/Seo"
import CallToAction from "../components/CallToAction"
import { DiscussionEmbed } from "disqus-react"

const useStyles = makeStyles((theme) => ({
	paper: {
		backgroundColor: "white",
		color: theme.palette.greenDark.main,
		position: "relative",
		zIndex: 2,
	},
	avatar: {
		display: "inline-block",
		width: 30,
		height: 30,
		marginRight: 10,
	},
	author: {
		display: "inline-block",
		verticalAlign: "bottom",
		padding: 3,
	},
}))
const Blogitem = ({ blog }) => {
	const [blogFields, setBlogFields] = useState({
		imgUrl: "",
		author: "",
		isLoaded: false,
		avatarUrl: "",
		categories: "",
	})

	useEffect(() => {
		const getImageUrl = axios.get(
			`https://cms.footprintforest.nl/wp-json/wp/v2/media/${blog.featured_media}`
		)

		const getAuthor = axios.get(
			`https://cms.footprintforest.nl/wp-json/wp/v2/users/${blog.author}`
		)

		const getCategories = axios.get(
			`https://cms.footprintforest.nl/wp-json/wp/v2/categories/${blog.categories[0]}`
		)

		Promise.all([getImageUrl, getAuthor, getCategories]).then((res) => {
			setBlogFields({
				imgUrl: res[0].data.media_details.sizes.full.source_url,
				author: res[1].data.name,
				isLoaded: true,
				categories: res[2].data.name,
				avatarUrl: res[1].data.avatar_urls,
			})
		})
	}, [])
	console.log(blog)

	const { title, content, excerpt, id, acf } = blog
	const { t } = useTranslation()
	const classes = useStyles()
	const lang = i18n.language == "en" ? "" : "/nl"
	const base = "https://www.footprintforest.com"
	const blogBase = t("/blog")
	const blogmeta = blog.yoast_meta[0].content ? blog.yoast_meta[0].content : ""
	const blogdate = new Date(blog.date).toLocaleDateString("en-US")
	const threadConfig = {
		url: base + blogBase + "/" + blog.slug,
		identifier: blog.slug,
		title: title.rendered,
		language: i18n.language,
	}

	return (
		<Fade in={true} {...(true ? { timeout: 1000 } : {})}>
			<Grid
				component="article"
				itemScope
				itemType="http://schema.org/Article"
				container
				noValidate
				alignItems="stretch"
			>
				<Seo
					title={title.rendered}
					description={blogmeta}
					pathSlug={blogBase + "/" + blog.slug}
					keywords=""
				/>

				<Box className="blog-header">
					{blogFields.imgUrl ? (
						<Fade in={true}>
							<img
								src={blogFields.imgUrl}
								width="100%"
								height="500px"
								alt={title.rendered}
							/>
						</Fade>
					) : (
						<Skeleton variant="rect" width="100%" height={500} />
					)}
					<Box p={5} className="blog-header-content">
						<Typography variant="h1" itemProp="name" color="initial">
							{title.rendered}
						</Typography>
						<Grid
							container
							direction="row"
							justify="flex-start"
							alignItems="center"
							spacing={5}
						>
							<Grid item xs={7} sm={3}>
								<Avatar
									className={classes.avatar}
									alt={blogFields.author}
									src={blogFields.avatarUrl[24]}
								/>
								<Typography
									variant="overline"
									className={classes.author}
									color="initial"
								>
									<strong>{blogFields.author}</strong>
								</Typography>
							</Grid>

							<Grid item xs={1} sm={3}>
								<Box display={{ xs: "none", sm: "block" }}>
									<Typography
										variant="overline"
										itemProp="author"
										itemScope
										itemType="http://schema.org/Person"
										className={classes.author}
										color="initial"
									>
										<strong>{blogFields.categories}</strong>
									</Typography>
								</Box>
							</Grid>
							<Grid item xs={4} sm={3}>
								<Typography
									variant="overline"
									className={classes.author}
									color="initial"
									itemProp="datePublished"
									content={blogdate}
								>
									<strong>{blogdate}</strong>
								</Typography>
							</Grid>
						</Grid>
					</Box>
				</Box>
				<Grid item itemProp="articleBody" xs={12}>
					<Box className="boxContainer blog-single home stretch">
						<Paper className={classes.paper}>
							<Box pt={5} p={8}>
								<Typography
									variant="body2"
									color="initial"
									dangerouslySetInnerHTML={{ __html: content.rendered }}
								></Typography>
								<CallToAction
									title={t("cta.general.title")}
									content={t("cta.general.content")}
									category={acf.linked_calc}
								/>
							</Box>
							<Box pt={3} p={8}>
								<DiscussionEmbed
									shortname="footprintforest"
									config={threadConfig}
								/>
							</Box>
						</Paper>
					</Box>
				</Grid>
				<Box p={4} style={{ maxWidth: 900, margin: "0px auto" }}>
					<Box pt={12} p={4}>
						<Typography variant="h3" align="center" color="initial">
							{t("More Stories")}
						</Typography>
						<Typography variant="body1" align="center" color="initial">
							{t(
								"We write about carbon, the environment and all other things related to the climit crisis. "
							)}
						</Typography>
					</Box>

					<BlogOverview limit={2} spacing={5} />
				</Box>
			</Grid>
		</Fade>
	)
}
export default Blogitem
